export const transformQueryFilter = ({
    level,
    queryFilters,
    isDashboardFilter,
}: {
    level?: number;
    queryFilters?: QueryFilterT[];
    isDashboardFilter?: boolean;
}): DataQueryFilterT[] | undefined => {
    if (queryFilters === undefined || queryFilters.length === 0)
        return undefined;
    return queryFilters.map(({ field, operation, value, valueScale }) => {
        const filter: DataQueryFilterT = {
            field,
            operation,
            level,
            is_dashboard_filter: isDashboardFilter,
            valueScale,
        };

        if (value) {
            filter.values = value.split('|');
        }

        return filter;
    });
};

/**
 * Transforms a QueryT object into a DataQueryT object
 */
export const transformQueryToDataQuery = (
    query: QueryT | undefined,
): DataQueryT => {
    if (query === undefined) {
        return {
            metrics: [],
        };
    }

    const metrics = query.metrics.map(({ field, aggregation }) => ({
        field,
        aggregation,
    }));

    const dimensions: DataQueryDimensionT[] | undefined =
        query.dimensions !== undefined && query.dimensions.length !== 0
            ? query.dimensions.map(({ field, scale, aggregationStrategy }) => ({
                  field,
                  scale,
                  aggregationStrategy,
              }))
            : undefined;

    const filters = [
        ...(transformQueryFilter({
            level: 0,
            queryFilters: query.detailsFilters,
            isDashboardFilter: false,
        }) || []),
        ...(transformQueryFilter({
            level: 1,
            queryFilters: query.dashboardFilters,
            isDashboardFilter: true,
        }) || []),
        ...(transformQueryFilter({
            level: 2,
            queryFilters: query.filters,
            isDashboardFilter: false,
        }) || []),
    ];

    const add_default_dimensions =
        query.add_default_dimensions !== undefined
            ? query.add_default_dimensions.toString()
            : undefined;

    return {
        metrics,
        dimensions,
        filters,
        add_default_dimensions,
    };
};
